import { render, staticRenderFns } from "./DIASRealEstateRealtorPayment.vue?vue&type=template&id=a5937716&"
import script from "./DIASRealEstateRealtorPayment.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstateRealtorPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports